export default "__VITE_ASSET__D$cb$jhX__"